import React,{useState,useEffect,useContext,useRef} from 'react'
import PrefixContext from "../../context/PrefixContext.js";
import Loading from '../../components/Loading/index.js'
import {Alert} from 'react-bootstrap'
import ReactToPrint from "react-to-print";
import {MdFileDownload} from 'react-icons/md'
import { v4 as uuidv4 } from 'uuid';
import '../t1/index.css'

//Template Components
import Skills from './tcomponents/Skills/index.js'
import About from './tcomponents/About/index.js'
import Social from './tcomponents/Social/index.js'
import Interests from './tcomponents/Interests/index.js'
import Education from './tcomponents/Education/index.js'
import Projects from './tcomponents/Projects/index.js'
import Certification from './tcomponents/Certification/index.js'
import CoCurricular from './tcomponents/CoCurricular/index.js'
import Footer from './tcomponents/Footer/index.js'
import Head from './tcomponents/Head/index.js'
import Languages from './tcomponents/Languages/index.js'
import Experience from './tcomponents/Experience/index.js'
import Profile from './tcomponents/Profile/index.js'

//Edit Data
import EditResume from "../EditModule/index.js"


function Index(props) {
    const PrefixContextData = useContext(PrefixContext);
    const printComponent = useRef();
    const clgLogo = PrefixContextData.cdnPrefixUrl+"clglogo_hxszsfwKZ.png";
    const [about, setabout] = useState();
    const [social, setsocial] = useState();
    const [education, setaboueducation] = useState();
    const [experience, setexperience] = useState();
    const [languages, setlanguages] = useState();
    const [skills, setskills] = useState();
    const [projects, setprojects] = useState();
    const [certificates, setcertificates] = useState();
    const [interests, setinterests] = useState();
    const [cocurricular, setcocurricular] = useState();
    const [customOrder, setcustomOrder] = useState();
    const [templateIdentity, settemplateIdentity] = useState();
    const [loading, setloading] = useState(true);
    const [dataset_id, setdataset_id] = useState(props.dataset_id)
    const components = {
        about: <About key={uuidv4()} {...about} />,
        profile: <Profile key={uuidv4()} {...about} />,
        education: <Education key={uuidv4()} education={education}/>,
        experience: <Experience key={uuidv4()} experience={experience}/>,
        projects: <Projects key={uuidv4()} projects={projects}/>,
        cocurricular: <CoCurricular key={uuidv4()} cocurricular={cocurricular}/>,
        skills: <Skills key={uuidv4()} {...skills}/>,
        social: <Social key={uuidv4()} {...social}/>,
        certification: <Certification key={uuidv4()} certificates={certificates}/>,
        languages: <Languages key={uuidv4()} languages={languages}/>,
        interests: <Interests key={uuidv4()} interests={interests}/>
    }

    const checkIfEmptyCustomOrder = (objectToCheck) =>{
        for (const item in objectToCheck) {
            if (objectToCheck[item].length !== 0)
                return false;
        }
        return true;
    }

    const refreshCustomOrderData = (cusData) =>{
        setcustomOrder(cusData);
    }

    const setData = () => {
        if(props.dataset_id !==null && props.dataset_id !== undefined)
        {
            if(checkIfEmptyCustomOrder(props.custom_order))
            {
                setcustomOrder(props.template_id.default_order);
            }
            else{
                setcustomOrder(props.custom_order);
            }
            settemplateIdentity(props.template_id.identity);
            setabout(props.dataset_id.about);
            setsocial(props.dataset_id.social);
            setaboueducation(props.dataset_id.education);
            setexperience(props.dataset_id.experience);
            setlanguages(props.dataset_id.languages);
            setskills(props.dataset_id.skills);
            setprojects(props.dataset_id.projects);
            setcertificates(props.dataset_id.certificates);
            setinterests(props.dataset_id.interests);
            setcocurricular(props.dataset_id.cocurricular);
            setloading(false);
        }
        else{
            setloading(true);
        }
    }

    const refreshData = (refreshedData) => {
        if(refreshedData !==null && refreshedData !== undefined)
        {
            setdataset_id(refreshedData);
            setabout(refreshedData.about);
            setsocial(refreshedData.social);
            setaboueducation(refreshedData.education);
            setexperience(refreshedData.experience);
            setlanguages(refreshedData.languages);
            setskills(refreshedData.skills);
            setprojects(refreshedData.projects);
            setcertificates(refreshedData.certificates);
            setinterests(refreshedData.interests);
            setcocurricular(refreshedData.cocurricular);
            setloading(false);
        }
        else{
            setloading(true);
        }
    }

    useEffect(() => {
        setData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    return (
        (loading === false) ?
        <>
        <div className={props.size + ' bg-secondary'}>
            <div className="page">
                <div className="page-container">
                    <div className="d-flex justify-content-around small-none">
                        <Alert className="w-75" variant="danger">
                            <span>Note: Check print backgrounds option & adjust page size & scale page to get the desired print. We recommended to use chrome for downloading the resume.</span>
                        </Alert>
                        <div className="d-flex flex-column mb-3">
                            <ReactToPrint
                            trigger={() => <button className="btn-primary mb-3"><MdFileDownload/>&nbsp;Download </button>}
                            content={() => printComponent.current}
                            />
                            <EditResume dataset_id={dataset_id} templateIdentity={templateIdentity} customOrder={customOrder} refreshCustomOrderData={refreshCustomOrderData} refreshData={refreshData}/>
                        </div>
                    </div>
                    <div ref={printComponent} id="template1">
                        <div className="custom-row" style={{minHeight:'1000px'}}>
                            <div className="column1">
                                <div className="image-container">
                                    <img className="clglogo" src={clgLogo} alt="College Logo" />
                                </div>
                                <div className="profile">
                                    <div className="details bg-second">
                                        <Profile {...about}/>
                                        <div className="contains-details">
                                            {customOrder.column1.map((element)=>{
                                                if(components[element] !== undefined)
                                                    return components[element]
                                                return 0;
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="column2">
                                <div className="padding-left-column heading">
                                    <Head {...about} />
                                    <div className="main-details">
                                        {customOrder.column2.map((element)=>{
                                            if(components[element] !== undefined)
                                                return components[element]
                                            return 0;
                                        })}
                                    </div>
                                </div>
                                <section className="template1-footer">
                                    <Footer/>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>  : ((props.size !== 'small') ? <Loading type="withImage"/> : '')
    )
}

export default Index
